module.exports = __webpack_public_path__ + "static/InteriorLandingHeroLiving_mobile-6af2605f62e8caed6a32c330943ba7b2.jpg";